import { render, staticRenderFns } from "./WeeklyHistoryList.vue?vue&type=template&id=96d6d1c8&scoped=true"
import script from "./WeeklyHistoryList.vue?vue&type=script&lang=js"
export * from "./WeeklyHistoryList.vue?vue&type=script&lang=js"
import style0 from "./WeeklyHistoryList.vue?vue&type=style&index=0&id=96d6d1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d6d1c8",
  null
  
)

export default component.exports